import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory, useParams } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";
import "./foodItem.css"

//functions
import {
  _t,
  getCookie,
  tableLoading,
  checkPermission,
  getSystemSettings,
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select, { components } from "react-select";
import makeAnimated from "react-select/animated";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { FoodContext } from "../../../../../contexts/Food";
import { FinanceContext } from "../../../../../contexts/Finance";
import { UserContext } from "../../../../../contexts/User";

const processType = [
  {id:1, value: "all", label:"Select All"},
  {id:2, value: "ready", label:"Ready Order"},
  {id:3, value: "served", label:"Served Order"},
  {id:4, value: "none", label:"None"}, 
];

const itemStatus = [
  {id:1, name:"True"},
  {id:2, name:"False"},
];

const CheckboxOption = (props) => {
  return (
    <components.Option {...props} className="d-flex align-items-center">
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null} // react-select handles this internally
      />{" "}
      <label style={{marginTop: "0.18rem"}} className="ml-1">{props.label}</label>
    </components.Option>
  );
};

const NewFoodItemDeptAction = () => {
  let { generalSettings, showManageStock } = useContext(SettingsContext);
  const { authUserInfo } = useContext(UserContext);

  let {
    deptTagForSearch,
    ingredientUnitForSearch,
    getIngredientUnit,
  } = useContext(RestaurantContext);

  let {
    //common
    loading,
    setLoading,
    //foodGroup
    foodDeptForSearch,
    foodGroupForSearch,
    //subcategory
    subCategoryForStatus,
    setPaginatedSubCategory,
    //weight
    weightForStatus,
    setPaginatedWeight,
    //flavor
    flavorForStatus,
    setPaginatedFlavor,
    //tax grp
    taxGroupForStatus,
    setPaginatedTaxGroup,
    //variation
    variantForStatus,
    setPaginatedVariant,
    //region
    regionForStatus,
    setPaginatedRegion,
    //packing
    packingTypeForStatus,
    setPaginatedPackingType,
    //generic
    genericForStatus,
    setPaginatedGeneric,
    //p unit
    productionUnitForStatus,
    setPaginatedProductionUnit,
    //product type
    productTypeForStatus,
    setPaginatedProductType,
    //property group
    propertyGroupForSearch,
    setFoodForSearch,
    //variations
    variationForSearch,
    //status
    foodStatusForSearch,
    foodStatusForStatus,
    setPaginatedFoodStatus,
    //season
    seasonForStatus,
    setPaginatedSeason,
    //pagination
    dataPaginating,
  } = useContext(FoodContext);

  const { cao3Active, getCoaL3 } = useContext(FinanceContext);

  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  const menuWisePrice = useRef(0);
  let [costForVariations, setCostForVariations] = useState(null);
  let [priceForVariations, setPriceForVariations] = useState(null);
  let [statusForVariations, setStatusForVariations] = useState(null);
  let [priceForItem, setPriceForItem] = useState({});
  let [selectedMenu, setSelectedMenu] = useState([]);
  let [priceForMenuVariation, setPriceForMenuVariation] = useState({});

  //new item
  let [newItem, setNewItem] = useState({
    item_group: null,
    sub_category: null,
    is_auto_name: "",
    auto_name: "",
    name: "",
    item_description: "",
    department: null,
    weight: "",
    production_unit: "",
    unit_of_measure: "",
    tax_group: "",
    flavour: "",
    variant: "",
    region: "",
    season: "",
    generic_setup: "",
    product_type: "",
    print_barcode: "",
    barcode: "",
    packing_type: "",
    packing_desc: "",
    is_feedback: "",
    touch_screen: "",
    shelf_life:"",
    wastage_variation: "",
    wastage: "",
    coa_cogs: null,
    coa_stock: null,
    coa_revenue: null,
    price: 0,
    cost_price: 0,
    cost_price_percent: 0,
    department: null,
    image: null,
    itemId: null,
    tax_rate: "",
    inc_tax_price: "",
    gp_percent: "",
    gp_amount:"",
    decimal_allow: "",
    is_qty_merge :"",
    isSpecial: 0,
    isDeal: 0,
    status: "",
  });

  const [filteredIngUnits, setFilteredIngUnits] = useState(null)

  useEffect(()=>{
    if(!ingredientUnitForSearch){
      getIngredientUnit();  
    }
    if(!cao3Active){
      getCoaL3();
    }
    if(!subCategoryForStatus){
      setPaginatedSubCategory(1)
    }
    if(!weightForStatus){
      setPaginatedWeight(1)
    }
    if(!flavorForStatus){
      setPaginatedFlavor(1)
    }
    if(!taxGroupForStatus){
      setPaginatedTaxGroup(1)
    }
    if(!variantForStatus){
      setPaginatedVariant(1)
    }
    if(!regionForStatus){
      setPaginatedRegion(1)
    }
    if(!packingTypeForStatus){
      setPaginatedPackingType(1)
    }
    if(!genericForStatus){
      setPaginatedGeneric(1)
    }
    if(!productionUnitForStatus){
      setPaginatedProductionUnit(1)
    }
    if(!productTypeForStatus){
      setPaginatedProductType(1)
    }
    if(!foodStatusForStatus){
      setPaginatedFoodStatus(1)
    }
    if(!seasonForStatus){
      setPaginatedSeason(1)
    }
    if(id){
      getFoodItem();
    }

    // saas integration
    if (
      authUserInfo.details?.user_type !== "superAdmin" ||  authUserInfo.details?.user_type !== "admin"
    ) {
      if(checkPermission(authUserInfo.permissions, "Manage Food"))
        history.push("/dashboard/manage/food/add-new");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Food Purchase"))
        history.push("/dashboard/manage/stock/food-purchase");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Purchase History"))
        history.push("/dashboard/manage/stock/purchase-history-food");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Purchase Invoice"))
        history.push("/dashboard/manage/stock/purchase-invoice");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Purchase Return"))
        history.push("/dashboard/manage/stock/purchase-return");   
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Store Requisition"))
        history.push("/dashboard/manage/stock/store-requisition");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Ingredient Group"))
        history.push("/dashboard/manage/stock/ingredient-group");  
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Production"))
        history.push("/dashboard/manage/stock/production");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Stock Issuance"))
        history.push("/dashboard/manage/stock/stock-issuance"); 
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Purchase Order"))
        history.push("/dashboard/manage/stock/purchase-order");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Goods Recieved Note"))
        history.push("/dashboard/manage/stock/goods-received-note");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Sale Order"))
        history.push("/dashboard/manage/stock/sale-order");    
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Opening Stock"))
        history.push("/dashboard/manage/stock/opening-stock"); 
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Gate Pass"))
        history.push("/dashboard/manage/stock/gate-pass");   
      else if(parseInt(getSystemSettings(generalSettings, "recipe_enable")) === 1 && showManageStock && checkPermission(authUserInfo.permissions, "MS Recipe"))
        history.push("/dashboard/manage/stock/view-recipe");
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Ingredient Item"))
        history.push("/dashboard/manage/stock/ingredient-item");  
      else if(showManageStock && checkPermission(authUserInfo.permissions, "MS Manage Supplier"))
        history.push("/dashboard/manage/stock/manage-supplier"); 
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Finished Goods"))
        history.push("/dashboard/manage/stock/finished-goods-history");
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Finished Goods Transfer"))
        history.push("/dashboard/manage/stock/finished-goods-transfer"); 
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Goods Adjustment"))
        history.push("/dashboard/manage/stock/finished-goods-adjustment");   
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Goods Acceptance"))
        history.push("/dashboard/manage/stock/finished-goods-acceptance");
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Finished Goods Issuance"))
        history.push("/dashboard/manage/stock/fg-issuance");  
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Finished Goods Requisition"))
        history.push("/dashboard/manage/stock/fg-requisition");   
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Finished Goods Discard"))
        history.push("/dashboard/manage/stock/finished-goods-discard");  
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Stock Transfer"))
        history.push("/dashboard/manage/stock/stock-transfer"); 
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS FG Packing"))
        history.push("/dashboard/manage/stock/fg-packing");
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS FG Hampers"))
        history.push("/dashboard/manage/stock/gift-hampers");
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Wastage Food"))
        history.push("/dashboard/manage/stock/wastage-food");      
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Stock Adjustment"))
        history.push("/dashboard/manage/stock/stock-adjustment"); 
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Supplier Payment"))
        history.push("/dashboard/manage/stock/supplier-payment");
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Day End Setting"))
        history.push("/dashboard/manage/stock/day-end-setting"); 
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Purchase Request"))
        history.push("/dashboard/manage/stock/purchase-request");
      else if (showManageStock && checkPermission(authUserInfo.permissions, "MS Sale Invoice"))
        history.push("/dashboard/manage/stock/sale-invoice");   
      else if (checkPermission(authUserInfo.permissions, "Manage User"))
        history.push("/dashboard/manage/user/admin-staff");
      else if (checkPermission(authUserInfo.permissions, "Manage Restaurant"))
        history.push("/dashboard/manage/restaurant/branches");
      else if (checkPermission(authUserInfo.permissions, "Manage Settings"))
        history.push("/dashboard/manage/settings/currencies");
      else {
        history.push("/dashboard");
        toast.error("You cannot access any manage.", {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      }
    }

  },[])

  useEffect(() => {
    if(!ingredientUnitForSearch) return;
    // const data = ingredientUnitForSearch?.filter(item => item.status === 1)
    // setFilteredIngUnits(data)
  }, [ingredientUnitForSearch])

  useEffect(() => {
    if(!generalSettings) return;

    if (getSystemSettings(generalSettings, "menu_wise_rate") == 1) {
      menuWisePrice.current = 1;
    }
  }, [generalSettings]);

  const getFoodItem = async () => {
    const url = BASE_URL + "/settings/food-item-attributes/" + parseInt(id);
    setLoading(true);
    try {
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
     
      let foodGroup = res.data.food_item_attributes.category_id ? {
          id: res.data.food_item_attributes.category_id,
          name: res.data.food_item_attributes.category_name,
        } : "";
      let department = res.data.food_item_attributes.department_id ? {
          id: res.data.food_item_attributes.department_id,
          name: res.data.food_item_attributes.department_name,
        } : null
      let subCategory = res.data.food_item_attributes.sub_category_id ? {
          id: res.data.food_item_attributes.sub_category_id,
          name: res.data.food_item_attributes.sub_category_name,
        } : "";

      let isAutoName = res.data.food_item_attributes.is_auto_name !== null ? 
        (res.data.food_item_attributes.is_auto_name ? itemStatus[0] : itemStatus[1]) 
        : "";
      
      let weight = res.data.food_item_attributes.weight_id ? {
          id: res.data.food_item_attributes.weight_id,
          weight: res.data.food_item_attributes.weight_name,
        } : "";
      
      let unitOfMeasure = res.data.food_item_attributes.measure_unit_id ? {
          id: res.data.food_item_attributes.measure_unit_id,
          name: res.data.food_item_attributes.measure_unit_name,
        } : "";
      
      let taxGroup = res.data.food_item_attributes.tax_group_id ? {
          id: res.data.food_item_attributes.tax_group_id,
          name: res.data.food_item_attributes.tax_group_name,
        } : "";
      
      let productionUnit = res.data.food_item_attributes.production_unit_id ? {
          id: res.data.food_item_attributes.production_unit_id,
          name: res.data.food_item_attributes.production_unit_name,
        } : "";

      let productType = res.data.food_item_attributes.product_type_id ? {
          id: res.data.food_item_attributes.product_type_id,
          name: res.data.food_item_attributes.product_type_name,
        }  : "";

      let region = res.data.food_item_attributes.region_id ? {
          id: res.data.food_item_attributes.region_id,
          name: res.data.food_item_attributes.region_name,
        } : "";  

      let season = res.data.food_item_attributes.season_id ? {
          id: res.data.food_item_attributes.season_id,
          name: res.data.food_item_attributes.season_name,
        } : "";
      
      let generic = res.data.food_item_attributes.generic_setup_id ? {
          id: res.data.food_item_attributes.generic_setup_id,
          name: res.data.food_item_attributes.generic_setup_name,
        } : "";
      
      let packingType = res.data.food_item_attributes.packing_type_id ? {
          id: res.data.food_item_attributes.packing_type_id,
          name: res.data.food_item_attributes.packing_type_name,
        } : "";
       
      let printBarcode = res.data.food_item_attributes.print_barcode !== null ?  
        (res.data.food_item_attributes.print_barcode ? itemStatus[0] : itemStatus[1]) 
        : "";

      let flavour = res.data.food_item_attributes.flavour_id ? {
          id: res.data.food_item_attributes.flavour_id,
          name: res.data.food_item_attributes.flavour_name,
        } : "";

      let variant = res.data.food_item_attributes.variant_id ? {
          id: res.data.food_item_attributes.variant_id,
          name: res.data.food_item_attributes.variant_name,
        } : "";

      let isFeedback = res.data.food_item_attributes.is_feedback !== null ?  
        (res.data.food_item_attributes.is_feedback ? itemStatus[0] : itemStatus[1]) 
        : "";
      
      let touchScreen = res.data.food_item_attributes.touch_screen !== null ?  
        (res.data.food_item_attributes.touch_screen ? itemStatus[0] : itemStatus[1]) 
        : "";

      let decimalAllow = res.data.food_item_attributes.is_decimal_allow !== null
        ? (res.data.food_item_attributes.is_decimal_allow ? itemStatus[0] : itemStatus[1])
        : "";
       
      let isQtyMerge = res.data.food_item_attributes.is_qty_merge !== null ?  
        (res.data.food_item_attributes.is_qty_merge ? itemStatus[0] : itemStatus[1]) 
        : ""; 

      let coaCogs = res.data.food_item_attributes.cogs_account_id ? {
          id: res.data.food_item_attributes.cogs_account_id,
          level3_name: res.data.food_item_attributes.cogs_account_name, 
        } : null;

      let coaStock = res.data.food_item_attributes.inventroy_account_id ? {
          id: res.data.food_item_attributes.inventroy_account_id,
          level3_name: res.data.food_item_attributes.inventroy_account_name, 
        } : null;

      let coaRevenue = res.data.food_item_attributes.revenue_account_id ? {
          id: res.data.food_item_attributes.revenue_account_id,
          level3_name: res.data.food_item_attributes.revenue_account_name,
        } : null;

      let status = res.data.food_item_attributes.item_status_id ? {
          id: res.data.food_item_attributes.item_status_id,
          name: res.data.food_item_attributes.item_status_name,
        } : null;

      // shelf_life:"",
      // wastage_variation: "",
      // wastage: "",
      // tax_rate: "",
      // inc_tax_price: "",
      // gp_percent: "",
      // gp_amount:"",
              
      // let deptTag = JSON.parse(res.data[0].menu_ids)
      //   ? JSON.parse(res.data[0].menu_ids).map((department) => {
      //       return deptTagForSearch.find((deptId) => deptId.id === department);
      //     })
      //   : null;
      // let propertyGroup = JSON.parse(res.data[0].property_groups)
      //   ? JSON.parse(res.data[0].property_groups).map((property) => {
      //       return propertyGroupForSearch.find(
      //         (propItem) => propItem.id === property
      //       );
      //     })
      //   : null;
      // setSelectedMenu(deptTag);

      // let variation = [];
      // if (menuWisePrice.current) {
      //   if (res.data[0].has_variation === "1") {
      //     let data = res.data[0].variations;
      //     let updateVariationPrice = {};
      //     let updateVariationCostPrice = {};
      //     let updateVariationStatus = {};
      //     let menuVariation = {};
      //     Object.keys(data).forEach((menuId) => {
      //       const variationArray = [];

      //       Object.keys(data[menuId]).forEach((item) => {
      //         // Add items to the array (you can add whatever you need here)
      //         variationArray.push({
      //           id: parseInt(item),
      //           name: data[menuId][item].name,
      //         });
      //         updateVariationPrice[menuId] = {
      //           ...updateVariationPrice[menuId],
      //           [item]: data[menuId][item].price,
      //         };
      //         updateVariationCostPrice[menuId] = {
      //           ...updateVariationCostPrice[menuId],
      //           [item]: data[menuId][item].cost_price,
      //         };
      //         updateVariationStatus[menuId] = {
      //           ...updateVariationStatus[menuId],
      //           [item]: data[menuId][item].status === 1 ? true : false,
      //         };

      //         menuVariation[menuId] = variationArray;

      //         if (Object.keys(data)[0] === menuId) {
      //           variation.push({
      //             id: item,
      //             name: data[menuId][item].name,
      //           });
      //         }
      //       });
      //     });
      //     setCostForVariations(updateVariationCostPrice);
      //     setPriceForVariations(updateVariationPrice);
      //     setStatusForVariations(updateVariationStatus);
      //     setPriceForMenuVariation(menuVariation);
      //   } else {
      //     let updatePrice = {};
      //     res.data[0].price.forEach((price) => {
      //       updatePrice[price.menu_id] = {
      //         menu_id: price.menu_id,
      //         menu_name: price.menu_name,
      //         price: price.price,
      //       };
      //     });
      //     setPriceForItem(updatePrice);
      //   }
      // } else {
      //   if (res.data[0].has_variation === "1") {
      //     res.data[0].variations.forEach((variationItem) => {
      //       setCostForVariations((curr) => ({
      //         ...curr,
      //         [variationItem.id]: variationItem.cost_price,
      //       }));
      //       setPriceForVariations((curr) => ({
      //         ...curr,
      //         [variationItem.id]: variationItem.price,
      //       }));
      //     });
      //   }
      // }

      setNewItem({
        item_group: foodGroup,
        name: res.data?.name,
        short_code: res.data.food_item_attributes.short_code,
        sub_category: subCategory,
        is_auto_name: isAutoName,
        weight: weight,
        region: region,
        department: department,
        auto_name: res.data.food_item_attributes.auto_name,
        item_description: res.data.item_description ?? "",
        unit_of_measure: unitOfMeasure,
        tax_group: taxGroup,
        production_unit: productionUnit,
        product_type: productType,
        packing_type: packingType,
        generic_setup: generic,
        barcode: res.data.food_item_attributes.barcode,
        print_barcode: printBarcode,
        flavour: flavour,
        variant: variant,
        packing_desc: res.data.food_item_attributes.packing_desc,
        season: season,
        price: res.data.price ? res.data.price : 0,
        cost_price: res.data.cost_price ?? 0,
        cost_price_percent: res.data.cost_price_percent ?? 0,
        wastage_variation: res.data.food_item_attributes.wastage_variation ?? "",
        wastage: res.data.food_item_attributes.wastage ?? "",
        shelf_life: res.data.food_item_attributes.shelf_life ?? "",
        tax_rate: res.data.food_item_attributes.tax_rate ?? 0,
        inc_tax_price: res.data.food_item_attributes.inc_tax_price ?? 0,
        gp_percent: res.data.food_item_attributes.gp_percent ?? 0,
        gp_amount: res.data.food_item_attributes.gp_amount ?? 0,
        image: null,
        itemId: res.data.id,
        is_feedback: isFeedback,
        touch_screen: touchScreen,
        decimal_allow: decimalAllow,
        is_qty_merge :isQtyMerge, 
        coa_cogs: coaCogs,
        coa_stock: coaStock,
        coa_revenue: coaRevenue,
        // hasProperty: res.data[0].has_property === "0" ? false : true,
        // properties: propertyGroup,
        // hasVariation: res.data[0].has_variation === "0" ? false : true,
        isSpecial: parseInt(res.data.is_special),
        isDeal: parseInt(res.data.is_deal),
        is_recipe: parseInt(res.data.is_recipe),
        status: status,
      });
      setLoading(false);
    } catch {
      setLoading(false);
    }
  };

  //handle Set hook
  const handleSetSelect = (name, value) => {
    setNewItem({ ...newItem, [name]: value});
  };

  const handleChangeOnSelect = (selected) => {
    if (!selected) {
      setNewItem({
        ...newItem,
        process_type: null,
      });
      return;
    }

    const values = selected.map((s) => s.value);

    // Handle "Select All"
    if (values.includes("all")) {
      const allOptions = processType.filter(
        (opt) => opt.value !== "all" && opt.value !== "none"
      );
      setNewItem({
        ...newItem,
        process_type: allOptions,
      });
      return;
    }

    // Handle "None"
    if (values.includes("none")) {
      setNewItem({
        ...newItem,
        process_type: [{ value: "none", label: "None" }],
      });
      return;
    }

    // Normal case
    setNewItem({
      ...newItem,
      process_type: selected.filter((s) => s.value !== "all"),
    });
  };

  const handleSelectedMenu = (menu) => {
    // setNewParty({ ...newParty, menu });
    setSelectedMenu(menu);
    if (menuWisePrice.current === 1) {
      const updatedPriceForVariation = {};
      const updatedPriceForItem = {};
      let updatePriceVariation = {};
      let updateCostVariation = {};
      let updateStatusVariation = {};
      menu &&
        menu.forEach((menuItem) => {
          updatedPriceForVariation[menuItem.id] = newItem.variations;
          updatedPriceForVariation[menuItem?.id] &&
            updatedPriceForVariation[menuItem?.id].forEach((variationItem) => {
              updatePriceVariation[menuItem?.id] = {
                ...updatePriceVariation[menuItem?.id],
                [variationItem.id]:
                  priceForVariations &&
                  priceForVariations[menuItem?.id] &&
                  priceForVariations[menuItem?.id][variationItem?.id]
                    ? priceForVariations[menuItem?.id][variationItem?.id]
                    : "",
              };
              updateCostVariation[menuItem?.id] = {
                ...updateCostVariation[menuItem?.id],
                [variationItem.id]:
                  costForVariations &&
                  costForVariations[menuItem?.id] &&
                  costForVariations[menuItem?.id][variationItem?.id]
                    ? costForVariations[menuItem?.id][variationItem?.id]
                    : 0,
              };
              updateStatusVariation[menuItem?.id] = {
                ...updateStatusVariation[menuItem?.id],
                [variationItem.id]:
                  statusForVariations &&
                  statusForVariations[menuItem?.id] &&
                  statusForVariations[menuItem?.id][variationItem?.id] === false
                    ? statusForVariations[menuItem?.id][variationItem?.id]
                    : true,
              };
            });
          updatedPriceForItem[menuItem.id] = {
            price:
              priceForItem && priceForItem[menuItem?.id]
                ? priceForItem[menuItem?.id].price
                : "",
            menu_name: menuItem.name,
            menu_id: menuItem.id,
          };
        });

      setPriceForVariations(updatePriceVariation);
      setCostForVariations(updateCostVariation);
      setStatusForVariations(updateStatusVariation);
      setPriceForMenuVariation(updatedPriceForVariation);
      setPriceForItem(updatedPriceForItem);
    }
  };

  //set variations hook
  const handleSetVariations = (variations) => {
    if (menuWisePrice.current) {
      let variation = {};
      let updatePriceVariation = {};
      let updateStatusVariation = {};
      let updateCostVariation = {};
      selectedMenu.forEach((menu) => {
        variation[menu.id] = variations;
        variations &&
          variations.forEach((variation) => {
            updatePriceVariation[menu?.id] = {
              ...updatePriceVariation[menu?.id],
              [variation.id]:
                priceForVariations &&
                priceForVariations[menu?.id] &&
                priceForVariations[menu?.id][variation?.id]
                  ? priceForVariations[menu?.id][variation.id]
                  : "",
            };
            updateCostVariation[menu?.id] = {
              ...updateCostVariation[menu?.id],
              [variation.id]:
                costForVariations &&
                costForVariations[menu?.id] &&
                costForVariations[menu?.id][variation?.id]
                  ? costForVariations[menu?.id][variation?.id]
                  : 0,
            };
            updateStatusVariation[menu?.id] = {
              ...updateStatusVariation[menu?.id],
              [variation.id]:
                statusForVariations &&
                statusForVariations[menu?.id] &&
                statusForVariations[menu?.id][variation.id] === false
                  ? statusForVariations[menu?.id][variation.id]
                  : true,
            };
          });
      });
      setPriceForMenuVariation(variation);
      setCostForVariations(updateCostVariation);
      setPriceForVariations(updatePriceVariation);
      setStatusForVariations(updateStatusVariation);
    } else {
      let updatePriceVariations = {};
      let updateCostVariations = {};
      let updateStatusVariation = {};
      variations &&
        variations.forEach((variation) => {
          updatePriceVariations[variation?.id] =
            priceForVariations && priceForVariations[variation?.id]
              ? priceForVariations[variation?.id]
              : "";
          updateCostVariations[variation?.id] =
            costForVariations && costForVariations[variation?.id]
              ? costForVariations[variation?.id]
              : 0;
          updateStatusVariation[variation?.id] =
            statusForVariations && statusForVariations[variation?.id] === false
              ? statusForVariations[variation?.id]
              : true;
        });
      setCostForVariations(updateCostVariations);
      setPriceForVariations(updatePriceVariations);
      setStatusForVariations(updateStatusVariation);
    }
    setNewItem({ ...newItem, variations });
  };

  //has variations
  const handleVariationCheckboxChange = (e) => {
    if (newItem.hasVariation === true) {
      setNewItem({
        ...newItem,
        variations: null,
        hasVariation: !newItem.hasVariation,
      });
    } else {
      setNewItem({ ...newItem, hasVariation: !newItem.hasVariation });
    }
  };
  //has Property
  const handlePropertyCheckboxChange = (e) => {
    if (newItem.hasProperty === true) {
      setNewItem({
        ...newItem,
        properties: null,
        hasProperty: !newItem.hasProperty,
      });
    } else {
      setNewItem({ ...newItem, hasProperty: !newItem.hasProperty });
    }
  };
  //set properties hook
  const handleSetPropertes = (properties) => {
    setNewItem({ ...newItem, properties });
  };

  //set status variation
  const handleVariationStatus = (variationId, menu = null) => {
    if (menuWisePrice.current) {
      let updateStatusVariation = { ...statusForVariations };
      updateStatusVariation[menu] = {
        ...updateStatusVariation[menu],
        [variationId]:
          updateStatusVariation &&
          updateStatusVariation[menu] &&
          updateStatusVariation[menu][variationId]
            ? !updateStatusVariation[menu][variationId]
            : true,
      };
      setStatusForVariations(updateStatusVariation);
    } else {
      setStatusForVariations({
        ...statusForVariations,
        [variationId]:
          statusForVariations && statusForVariations[variationId]
            ? !statusForVariations[variationId]
            : true,
      });
    }
  };
  //set each variation price
  const handleVariationPrice = (e, menu = null) => {
    if (menuWisePrice.current) {
      let updatePriceVariation = { ...priceForVariations };
      updatePriceVariation[menu] = {
        ...updatePriceVariation[menu],
        [e.target.name]: e.target.value,
      };
      setPriceForVariations(updatePriceVariation);
    } else {
      setPriceForVariations({
        ...priceForVariations,
        [e.target.name]: e.target.value,
      });
    }
  };
  const handleVariationCost = (e, menu) => {
    const name = e.target.name.replace(/(-cost)/g, "");
    if (menuWisePrice.current) {
      let updateCostVariation = { ...costForVariations };
      // auto cost price update
      //  selectedMenu.forEach((menu)=>{
      //   updateCostVariation[menu.id] = {
      //     ...updateCostVariation[menu.id],
      //     [name]: e.target.value,
      //   }
      //  })
      updateCostVariation[menu] = {
        ...updateCostVariation[menu],
        [name]: e.target.value,
      };
      setCostForVariations(updateCostVariation);
    } else {
      setCostForVariations({
        ...costForVariations,
        [name]: e.target.value,
      });
    }
  };

  //is special
  const handleCheckboxChange = (name,e) => {
    setNewItem({
      ...newItem,
      [name]: e.target.checked ? 1 : 0,
    });
  };

  //is recipe
  const handleRecipeCheckboxChange = (e) => {
    setNewItem({
      ...newItem,
      is_recipe: newItem.is_recipe ? 0 : 1,
    });
  };
  //set image hook
  const handleItemImage = (e) => {
    setNewItem({
      ...newItem,
      [e.target.name]: e.target.files[0],
    });
  };

  const handleStatus = (e) => {
    setNewItem({
      ...newItem,
      status: !newItem.status,
    });
  };

  //on change input field
  const handleChange = (e) => {
    const key = Object.keys(priceForItem)[0];
    // if (e.target.name === "cost_price") {
    //   const price = menuWisePrice.current
    //     ? priceForItem[key].price
    //     : newItem.price;
    //   let cost_price =
    //     parseFloat(e.target.value) > parseFloat(price) ? price : e.target.value;
    //   if (price === "") {
    //     cost_price = 0;
    //   } else {
    //     let generate_percent = (parseInt(cost_price) / parseInt(price)) * 100;

    //     setNewItem({
    //       ...newItem,
    //       cost_price_percent: generate_percent,
    //       cost_price: cost_price,
    //     });
    //   }
    // } else if (e.target.name === "cost_price_percent") {
    //   let cost_price_percent =
    //     parseFloat(e.target.value) > 100 ? 100 : e.target.value;
    //   const price = menuWisePrice.current
    //     ? priceForItem[key]?.price
    //     : newItem.price;
    //   if (price === "") {
    //     cost_price_percent = 0;
    //   } else {
    //     let generate_amount =
    //       (parseInt(price) / 100) * parseInt(cost_price_percent);
    //     setNewItem({
    //       ...newItem,
    //       cost_price_percent: cost_price_percent,
    //       cost_price: generate_amount,
    //     });
    //   }
    // } else {
    // }
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };

  //on change menu wise price
  const handleMenuPrice = (e, key) => {
    setPriceForItem({
      ...priceForItem,
      [key]: {
        ...priceForItem[key],
        [e.target.name]: e.target.value,
      },
    });
  };

  //handle Set item group hook
  const handleSetItemGroup = (item_group) => {
    let group = item_group;
    setNewItem({ ...newItem, item_group: group, sub_category: null });
  };
 
  //post req of food item add
  const handleFoodItemUpdate = (e) => {
    e.preventDefault();
    // if (selectedMenu == null || selectedMenu?.length === 0) {
    //   toast.error(`${_t(t("Please select menu group"))}`, {
    //     position: "bottom-center",
    //     autoClose: 10000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     className: "text-center toast-notification",
    //   });
    //   return false;
    // }

    if (newItem.item_group === null) {
      toast.error(`${_t(t("Please select category"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return false;
    }

    // if (
    //   newItem.hasProperty === true &&
    //   (newItem.properties === null || newItem.properties?.length === 0)
    // ) {
    //   toast.error(`${_t(t("Please select properties"))}`, {
    //     position: "bottom-center",
    //     autoClose: 10000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     className: "text-center toast-notification",
    //   });
    //   return false;
    // }
    // if (newItem.hasVariation === true && newItem.variations === null) {
    //   toast.error(`${_t(t("Please select variations"))}`, {
    //     position: "bottom-center",
    //     autoClose: 10000,
    //     hideProgressBar: false,
    //     closeOnClick: true,
    //     pauseOnHover: true,
    //     className: "text-center toast-notification",
    //   });
    //   return false;
    // }
    
    if(!newItem.name || !newItem.department || !newItem.sub_category || !newItem.status){
      toast.error(`${_t(t("Please fill all the fields"))}`, {
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      setLoading(false);
      return
    }
    setLoading(true);
    const method = id ? "put" : "post";
    
    let formData = new FormData();
    //formData.append("food_group_id", newItem.item_group.id);
    formData.append('_method', method); 
    formData.append("name", newItem.name);
    formData.append("item_id", newItem.itemId);
    formData.append("short_code", newItem.short_code);
    formData.append("item_description", newItem.item_description);
    formData.append("is_auto_name", newItem.is_auto_name?.name ?? "");
    formData.append("auto_name", newItem.auto_name);
    formData.append("category_id", newItem.item_group.id);
    formData.append("category_name", newItem.item_group.name);
    formData.append("sub_category_id", newItem.sub_category.id);
    formData.append("sub_category_name", newItem.sub_category.name);
    formData.append("department_id", newItem.department?.id);
    formData.append("department_name", newItem.department?.name);
    formData.append("weight_id", newItem.weight?.id ?? "");
    formData.append("weight_name", newItem.weight?.weight ?? "");
    formData.append("production_unit_id", newItem.production_unit?.id ?? "");
    formData.append("production_unit_name", newItem.production_unit?.name ?? "");
    formData.append("measure_unit_id", newItem.unit_of_measure?.id ?? "");
    formData.append("measure_unit_name", newItem.unit_of_measure?.name ?? "");
    formData.append("tax_group_id", newItem.tax_group?.id ?? "");
    formData.append("tax_group_name", newItem.tax_group?.name ?? "");
    formData.append("flavour_id", newItem.flavour?.id ?? "");
    formData.append("flavour_name", newItem.flavour?.name ?? "");
    formData.append("variant_id", newItem.variant?.id ?? "");
    formData.append("variant_name", newItem.variant?.name ?? "");
    formData.append("region_id", newItem.region?.id ?? "");
    formData.append("region_name", newItem.region?.name ?? "");
    formData.append("season_id", newItem.season?.id ?? "");
    formData.append("season_name", newItem.season?.name ?? "");
    formData.append("generic_setup_id", newItem.generic_setup?.id ?? "");
    formData.append("generic_setup_name", newItem.generic_setup?.name ?? "");
    formData.append("product_type_id", newItem.product_type?.id ?? "");
    formData.append("product_type_name", newItem.product_type?.name ?? "");
    formData.append("print_barcode", newItem.print_barcode?.name ?? "");
    formData.append("barcode", newItem.barcode ?? "");
    formData.append("packing_type_id", newItem.packing_type?.id ?? "");
    formData.append("packing_type_name", newItem.packing_type?.name ?? "");
    formData.append("packing_desc", newItem.packing_desc ?? "");
    formData.append("is_feedback", newItem.is_feedback?.name ?? "");
    formData.append("touch_screen", newItem.touch_screen?.name ?? "");
    formData.append("shelf_life", newItem.shelf_life ?? "");
    formData.append("wastage_variation", newItem.wastage_variation ?? "");
    formData.append("wastage", newItem.wastage ?? "");
    formData.append("inventory_account_id", newItem.coa_stock?.id ?? "");
    formData.append("inventory_account_name", newItem.coa_stock?.level3_level3_name ?? "");
    formData.append("revenue_account_id", newItem.coa_revenue?.id ?? "");
    formData.append("revenue_account_name", newItem.coa_revenue?.level3_name ?? "");
    formData.append("cogs_account_id", newItem.coa_cogs?.id ?? "");
    formData.append("cogs_account_name", newItem.coa_cogs?.level3_name ?? "");
    formData.append("price", newItem.price);
    formData.append("cost_price", newItem.cost_price);
    formData.append("cost_price_percent", newItem.cost_price_percent);
    formData.append("inc_tax_price", newItem.inc_tax_price);
    formData.append("gp_percent", newItem.gp_percent);
    formData.append("gp_amount", newItem.gp_amount);
    formData.append("is_decimal_allow", newItem.decimal_allow?.name ?? "");
    formData.append("is_qty_merge", newItem.is_qty_merge?.name ?? "");
    formData.append("is_special", newItem.isSpecial);
    formData.append("is_deal", newItem.isDeal);
    formData.append("image", newItem.image);
    formData.append("item_status_id", newItem.status?.id ?? 1);
    formData.append("item_status_name", newItem.status?.name ?? "");

    // formData.append("hasProperty", newItem.hasProperty === true ? 1 : 0);
    // if (newItem.hasProperty === true) {
    //   formData.append("hasProperty", 1);
    //   let tempArray = [];
    //   newItem.properties.map((pItem) => {
    //     tempArray.push(pItem.id);
    //   });
    //   formData.append("properties", tempArray);
    // }

    // formData.append("hasVariation", newItem.hasVariation === true ? 1 : 0);
    // formData.append("is_recipe", newItem.is_recipe);
    // formData.append("isSpecial", newItem.isSpecial);
    // formData.append("is_deal", newItem.isDeal);
    // formData.append("item_status", newItem.status === true ? 1 : 0);
    // formData.append("menu_wise_price", menuWisePrice.current ? 1 : 0);

    // if (menuWisePrice.current) {
    //   if (newItem.hasVariation === false) {
    //     formData.append("menu_price", JSON.stringify(priceForItem));
    //     formData.append(
    //       "cost_price",
    //       newItem.cost_price ? newItem.cost_price : 0
    //     );
    //     formData.append(
    //       "cost_price_percent",
    //       newItem.cost_price_percent ? newItem.cost_price_percent : 0
    //     );
    //   } else {
    //     // let tempData = Object.entries(priceForVariations);
    //     // tempData.map((item) => {
    //     //   formData.append("variations[]", item);
    //     // });
    //     let variationObj = {};
    //     const tempKeys = priceForVariations && Object.keys(priceForVariations);

    //     tempKeys &&
    //       tempKeys.forEach((key) => {
    //         Object.keys(priceForVariations[key]).map((keys) => {
    //           let price = priceForVariations[key][keys];
    //           let costVariation =
    //             costForVariations[key] && costForVariations[key][keys];
    //           let cost =
    //             costForVariations &&
    //             costForVariations[key] &&
    //             costForVariations[key][keys]
    //               ? costVariation
    //               : "0";
    //           let status =
    //             statusForVariations &&
    //             statusForVariations[key] &&
    //             statusForVariations[key][keys]
    //               ? 1
    //               : 0;
    //           variationObj[key] = {
    //             ...variationObj[key],
    //             [keys]: {
    //               cost_price: cost,
    //               price: price,
    //               status: status,
    //               menu_id: key,
    //             },
    //           };
    //         });
    //       });
    //     const payloadString = JSON.stringify(variationObj);
    //     formData.append("variations", payloadString);
    //   }
    // } else {
    //   if (newItem.hasVariation === false) {
    //     formData.append("price", newItem.price);
    //     formData.append(
    //       "cost_price",
    //       newItem.cost_price ? newItem.cost_price : 0
    //     );
    //     formData.append(
    //       "cost_price_percent",
    //       newItem.cost_price_percent ? newItem.cost_price_percent : 0
    //     );
    //   } else {
    //     //converting variations and prices to array
    //     console.log("1111111111newitem ", newItem, priceForVariations);
    //     // let slugArray = [];
    //     // newItem.variations.map((newVarItem) => {
    //     //   slugArray.push(newVarItem.id);
    //     // });
    //     // slugArray.map((slugItem) => {
    //     //   formData.append("slugOfVariations[]", slugItem);
    //     // });

    //     let variationObj = {};
    //     const tempKeys = priceForVariations && Object.keys(priceForVariations);
    //     tempKeys?.length > 0 &&
    //       tempKeys.forEach((key) => {
    //         const price = priceForVariations[key];
    //         const cost =
    //           costForVariations && costForVariations[key]
    //             ? costForVariations[key]
    //             : "0";
    //         const status =
    //           statusForVariations && statusForVariations[key] ? 1 : 0;
    //         //formData.append("variations[]", [key, price, cost]);
    //         variationObj[key] = { price, cost, status };
    //       });
    //     const payloadString = JSON.stringify(variationObj);
    //     formData.append("variations", payloadString);
    //   }
    // }

    //for food_group
    // let foodArray = [];
    // newItem.item_group.map((Item) => {
    //   foodArray.push(Item.id);
    // });

    // formData.append("food_group_id", foodArray.toString());
    //for menu_group
    // let tempArray = [];
    // selectedMenu.map((Item) => {
    //   tempArray.push(Item.id);
    // });
    // formData.append("menu_ids", tempArray.toString());
    const endPoint = id ? ("/settings/food-item-attributes/" + id) : "/settings/food-item-attributes";
    const url = BASE_URL + endPoint;
    return axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setFoodForSearch(res.data[1]);
        setNewItem({
          item_group: null,
          sub_category: null,
          is_auto_name: "",
          auto_name: "",
          name: "",
          item_description: "",
          department: null,
          weight: "",
          production_unit: "",
          unit_of_measure: "",
          tax_group: "",
          flavour: "",
          variant: "",
          region: "",
          season: "",
          generic_setup: "",
          product_type: "",
          print_barcode: "",
          barcode: "",
          packing_type: "",
          packing_desc: "",
          is_feedback: "",
          touch_screen: "",
          shelf_life:"",
          wastage_variation: "",
          wastage: "",
          coa_cogs: null,
          coa_stock: null,
          coa_revenue: null,
          price: 0,
          cost_price: 0,
          cost_price_percent: 0,
          department: null,
          image: null,
          itemId: null,
          tax_rate: "",
          inc_tax_price: "",
          gp_percent: "",
          gp_amount:"",
          decimal_allow: "",
          is_qty_merge :"",
          isSpecial: 0,
          isDeal: 0,
          status: "",
        });
        setSelectedMenu([]);
        setPriceForMenuVariation({});
        setPriceForItem({});
        setPriceForVariations(null);
        setCostForVariations(null);
        // getFoodItemsForPOS();
        history.push("/dashboard/manage/food/all-items");
        setLoading(false);
        toast.success(`${_t(t("Food item has been updated"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch((error) => {
        setLoading(false);
        if (error.response.data.errors && error.response?.status == "422") {
          toast.error(`${_t(t(error.response.data.errors?.name[0]))}`, {
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
          return;
        }
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        // if (error.response.data.errors.image) {
        //   error.response.data.errors.image.forEach((item) => {
        //     if (item === "Please select a valid image file") {
        //       toast.error(`${_t(t("Please select a valid image file"))}`, {
        //         position: "bottom-center",
        //         autoClose: 10000,
        //         hideProgressBar: false,
        //         closeOnClick: true,
        //         pauseOnHover: true,
        //         className: "text-center toast-notification",
        //       });
        //     }
        //     if (item === "Please select a file less than 5MB") {

        //     }
        //   });
        // }
      });
  };

  return (
    <>
      <Helmet>
        <title>{_t(t( id ? "Edit Item" : "Add Item"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ManageSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <div className={`${dataPaginating && "loading"}`}></div>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {loading === true
                      ? tableLoading()
                      : [
                          // start here
                          <div key="smtp-form">
                            <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                              <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                                <ul className="t-list fk-breadcrumb">
                                  <li className="fk-breadcrumb__list">
                                    <span className="t-link fk-breadcrumb__link text-capitalize">
                                      {_t(t(id ? "Edit item" : "Add item"))}
                                    </span>
                                  </li>
                                </ul>
                              </div>
                              <div className="col-md-6 col-lg-7">
                                <div className="row gx-3 align-items-center"></div>
                              </div>
                            </div>

                            {/* Form starts here */}
                            <form
                              className="row card p-2 mx-3 mb-5 sm-text"
                              onSubmit={handleFoodItemUpdate}
                              autoComplete="off"
                            >
                              <div className="section-item-box">
                                <div className="section-item-title lg-text product-infor">
                                  Product Name Description
                                </div>
                                <div className="row">
                                  <div className="form-group col-md-3 col-6 mt-2">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="item_group"
                                        className="control-label"
                                      >
                                        {_t(t("Select Category"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <Select
                                      options={foodGroupForSearch}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newItem.item_group}
                                      classNamePrefix="select"
                                      onChange={handleSetItemGroup}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select a category")) +
                                        ".."
                                      }
                                    />
                                  </div>
                                  <div className="form-group col-md-3 col-6 mt-2">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="item_group"
                                        className="control-label"
                                      >
                                        {_t(t("Sub Category"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <Select
                                      options={(subCategoryForStatus && newItem.item_group && subCategoryForStatus[newItem.item_group?.id]) ?? []}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newItem.sub_category}
                                      classNamePrefix="select"
                                      onChange={(sub_category)=>handleSetSelect("sub_category", sub_category)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select sub category")) +
                                        ".."
                                      }
                                    />
                                  </div>
                                  <div className="form-group mt-2 col-6 col-md-4">
                                    <div className="mb-1 text-left">
                                      <label
                                        htmlFor="department"
                                        className="control-label"
                                      >
                                        {_t(t("Department"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <Select
                                      options={foodDeptForSearch || []}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newItem.department || ""}
                                      classNamePrefix="select"
                                      onChange={(department) => handleSetSelect("department", department)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select department")) + ".."
                                      }
                                      required
                                    />
                                  </div>
                                  <div className="form-group mt-2 col-6 col-md-2">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="short_code"
                                        className="control-label"
                                      >
                                        {_t(t("Auto Name"))}
                                      </label>
                                    </div>
                                    <Select
                                      options={itemStatus}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newItem?.is_auto_name}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      maxMenuHeight="200px"
                                      onChange={(name)=>handleSetSelect("is_auto_name", name)}
                                      placeholder={
                                        _t(t("Auto name")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="form-group mt-2 col-md-4">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="name"
                                        className="control-label"
                                      >
                                        {_t(t("Name"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        name="name"
                                        onChange={handleChange}
                                        value={newItem.name}
                                        placeholder="e.g. Spicy chicken burger"
                                        required
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group mt-2 col-6 col-md-2">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="short_code"
                                        className="control-label"
                                      >
                                        {_t(t("Short Name"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="short_code"
                                        name="short_code"
                                        onChange={handleChange}
                                        value={newItem.short_code || ""}
                                        placeholder="e.g. scb"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group mt-2 col-2">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="auto_name"
                                        className="control-label"
                                      >
                                        {_t(t("Auto Name"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="auto_name"
                                        name="auto_name"
                                        onChange={handleChange}
                                        value={newItem.auto_name}
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group mt-2 col-4">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="item_description"
                                        className="control-label"
                                      >
                                        {_t(t("Item Description"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <textarea
                                        type="text"
                                        rows="1"
                                        className="form-control"
                                        id="item_description"
                                        name="item_description"
                                        onChange={handleChange}
                                        value={newItem.item_description}
                                        placeholder="e.g. 1 beef burger, 2 drinks"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="section-item-box">
                                <div className="section-item-title lg-text product-desc">
                                  Product Parameter
                                </div>
                                <div className="row">
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="weight" className="form-label mb-1">
                                      {_t(t("Weight"))}{" "}
                                    </label>
                                    <Select
                                      options={weightForStatus}
                                      value={newItem.weight}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.weight}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(weight) => handleSetSelect("weight", weight)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Select weight")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="weight" className="form-label mb-1">
                                      {_t(t("Production Unit"))}{" "}
                                    </label>
                                    <Select
                                      options={productionUnitForStatus}
                                      value={newItem.production_unit}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(production_unit) => handleSetSelect("production_unit", production_unit)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Select Production Unit")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("Unit Of Measure"))}{" "}
                                    </label>
                                    <Select
                                      options={productionUnitForStatus}
                                      value={newItem.unit_of_measure}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(base) => handleSetSelect("unit_of_measure", base)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select unit")) + ".."
                                      }
                                    />
                                  </div>
                                  {/* <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="product_limit" className="form-label mb-1">
                                      {_t(t("Process Type"))}{" "}
                                    </label>
                                    <Select
                                      options={processType ?? []}
                                      value={newItem.process_type}
                                      components={{ Option: CheckboxOption}}
                                      getOptionLabel={(option) => option.label}
                                      getOptionValue={(option) => option.id}
                                      isMulti
                                      closeMenuOnSelect={false}
                                      hideSelectedOptions={true}
                                      onChange={(process) => handleChangeOnSelect(process)}
                                      maxMenuHeight="200px"
                                    />
                                  </div> */}
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("Tax Group"))}{" "}
                                    </label>
                                    <Select
                                      options={taxGroupForStatus ?? []}
                                      value={newItem.tax_group}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(tax) => handleSetSelect("tax_group", tax)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select tax")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("Flavour"))}{" "}
                                    </label>
                                    <Select
                                      options={flavorForStatus ?? []}
                                      value={newItem.flavour}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(flavour) => handleSetSelect("flavour", flavour)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select flavour")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("Variant"))}{" "}
                                    </label>
                                    <Select
                                      options={variantForStatus ?? []}
                                      value={newItem.variant}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(variant) => handleSetSelect("variant", variant)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select variant")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("Region"))}{" "}
                                    </label>
                                    <Select
                                      options={regionForStatus ?? []}
                                      value={newItem.region}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(region) => handleSetSelect("region", region)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select region")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("Season"))}{" "}
                                    </label>
                                    <Select
                                      options={seasonForStatus ?? []}
                                      value={newItem.season}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(season) => handleSetSelect("season", season)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select season")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="generic_setup" className="form-label mb-1">
                                      {_t(t("Generic SetUp"))}{" "}
                                    </label>
                                    <Select
                                      options={genericForStatus ?? []}
                                      value={newItem.generic_setup}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(generic_setup) => handleSetSelect("generic_setup", generic_setup)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select generic")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="production_limit" className="form-label mb-1">
                                      {_t(t("Product Type"))}{" "}
                                    </label>
                                    <Select
                                      options={productTypeForStatus ?? []}
                                      value={newItem.product_type}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(product_type) => handleSetSelect("product_type", product_type)}
                                      maxMenuHeight="200px"
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="section-item-box">
                                <div className="section-item-title lg-text product-params">
                                  Product General Description
                                </div>
                                <div className="row">
                                  <div className="form-group mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="print_barcode"
                                        className="control-label"
                                      >
                                        {_t(t("Print Barcode"))}
                                      </label>
                                    </div>
                                    <Select
                                      options={itemStatus}
                                      components={makeAnimated()}
                                      value={newItem.print_barcode}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      maxMenuHeight="200px"
                                      onChange={(print_barcode)=>handleSetSelect("print_barcode", print_barcode)}
                                      placeholder={
                                        _t(t("barcode")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="form-group mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="barcode"
                                        className="control-label"
                                      >
                                        {_t(t("Barcode"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="barcode"
                                        name="barcode"
                                        onChange={handleChange}
                                        value={newItem.barcode || ""}
                                        placeholder="e.g. c123"
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("Packing Type"))}{" "}
                                    </label>
                                    <Select
                                      options={packingTypeForStatus}
                                      value={newItem.packing_type}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(base) => handleSetSelect("packing_type", base)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select packing")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="packing_desc" className="form-label mb-1">
                                      {_t(t("Packing Description"))}{" "}
                                    </label>
                                    <div className="mb-1">
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(
                                            evt.key
                                          ) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        className="form-control"
                                        id="packing_desc"
                                        name="packing_desc"
                                        onChange={handleChange}
                                        value={newItem.packing_desc || ""}
                                        placeholder="e.g. 1"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="is_feedback"
                                        className="control-label"
                                      >
                                        {_t(t("Is Feedback"))}
                                      </label>
                                    </div>
                                    <Select
                                      options={itemStatus}
                                      components={makeAnimated()}
                                      value={newItem.is_feedback}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      maxMenuHeight="200px"
                                      onChange={(is_feedback)=>handleSetSelect("is_feedback", is_feedback)}
                                      placeholder={
                                        _t(t("fedback")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="touch_screen"
                                        className="control-label"
                                      >
                                        {_t(t("Touch Screen"))}
                                      </label>
                                    </div>
                                    <Select
                                      options={itemStatus}
                                      components={makeAnimated()}
                                      value={newItem.touch_screen}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      maxMenuHeight="200px"
                                      onChange={(touch_screen)=>handleSetSelect("touch_screen", touch_screen)}
                                      placeholder={
                                        _t(t("Touch screen")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="shelf_life" className="form-label mb-1">
                                      {_t(t("Shelf Life"))}{" "}
                                      <span className="text-danger">(In hours)</span>
                                    </label>
                                    <div className="mb-1">
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(
                                            evt.key
                                          ) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        className="form-control"
                                        id="shelf_life"
                                        name="shelf_life"
                                        onChange={handleChange}
                                        value={newItem.shelf_life || ""}
                                        placeholder=""
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="wastage_variation" className="form-label mb-1">
                                      {_t(t("Wastage Variation %"))}{" "}
                                    </label>
                                    <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(
                                            evt.key
                                          ) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        max={100}
                                        className="form-control"
                                        id="wastage_variation"
                                        name="wastage_variation"
                                        onChange={handleChange}
                                        value={newItem.wastage_variation || ""}
                                        placeholder="e.g. 1"
                                      />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="wastage" className="form-label mb-1">
                                      {_t(t("Wastage %"))}{" "}
                                    </label>
                                    <input
                                      type="number"
                                      onKeyDown={(evt) =>
                                        [
                                          "e",
                                          "E",
                                          "+",
                                          "-",
                                          "ArrowUp",
                                          "ArrowDown",
                                        ].includes(
                                          evt.key
                                        ) &&
                                        evt.preventDefault()
                                      }
                                      onWheel={(e) =>
                                        e.target.blur()
                                      }
                                      max={100}
                                      className="form-control"
                                      id="wastage"
                                      name="wastage"
                                      onChange={handleChange}
                                      value={newItem.wastage || ""}
                                      placeholder="e.g. 1"
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("COA (stock)"))}{" "}
                                    </label>
                                    <Select
                                      options={cao3Active ?? []}
                                      value={newItem.coa_stock}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.level3_name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(coa_stock) => handleSetSelect("coa_stock", coa_stock)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select coa")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("COA (revenue)"))}{" "}
                                    </label>
                                    <Select
                                      options={cao3Active ?? []}
                                      value={newItem.coa_revenue}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.level3_name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(coa_revenue) => handleSetSelect("coa_revenue", coa_revenue)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select coa")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <label htmlFor="_unit" className="form-label mb-1">
                                      {_t(t("COA (cogs)"))}{" "}
                                    </label>
                                    <Select
                                      options={cao3Active ?? []}
                                      value={newItem.coa_cogs}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.level3_name}
                                      getOptionValue={(option) => option.id}
                                      classNamePrefix="select"
                                      onChange={(coa_cogs) => handleSetSelect("coa_cogs", coa_cogs)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select coa")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="cost_price"
                                        className="control-label"
                                      >
                                        {_t(t("Cost Price"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        id="cost_price"
                                        step="0.0001"
                                        type="number"
                                        className="form-control"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(evt.key) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        name="cost_price"
                                        value={newItem.cost_price}
                                        onChange={handleChange}
                                        placeholder="e.g. 200"
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="price"
                                        className="control-label"
                                      >
                                        {_t(t("Price"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        id="price"
                                        step="0.0001"
                                        type="number"
                                        //max={newItem.price}
                                        className="form-control"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(evt.key) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        name="price"
                                        value={newItem.price}
                                        onChange={handleChange}
                                        placeholder="e.g. 350"
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="tax_rate"
                                        className="control-label"
                                      >
                                        {_t(t("Tax Rate"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        id="tax_rate"
                                        step="0.0001"
                                        type="number"
                                        //max={newItem.tax_rate}
                                        className="form-control"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(evt.key) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        name="tax_rate"
                                        value={newItem.tax_rate}
                                        onChange={handleChange}
                                        placeholder="e.g. 350"
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="inc_tax_price"
                                        className="control-label"
                                      >
                                        {_t(t("Inc. Tax Price"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        id="inc_tax_price"
                                        step="0.0001"
                                        type="number"
                                        //max={newItem.inc_tax_price}
                                        className="form-control"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(evt.key) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        name="inc_tax_price"
                                        value={newItem.inc_tax_price}
                                        onChange={handleChange}
                                        placeholder="e.g. 350"
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="gp_percent"
                                        className="control-label"
                                      >
                                        {_t(t("GP %"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        id="gp_percent"
                                        step="0.0001"
                                        type="number"
                                        //max={newItem.gp_percent}
                                        className="form-control"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(evt.key) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        name="gp_percent"
                                        value={newItem.gp_percent}
                                        onChange={handleChange}
                                        placeholder="e.g. 350"
                                      />
                                    </div>
                                  </div>
                                  <div className="mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="gp_amount"
                                        className="control-label"
                                      >
                                        {_t(t("GP Amount"))}
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        id="gp_amount"
                                        step="0.0001"
                                        type="number"
                                        //max={newItem.gp_amount}
                                        className="form-control"
                                        onKeyDown={(evt) =>
                                          [
                                            "e",
                                            "E",
                                            "+",
                                            "-",
                                            "ArrowUp",
                                            "ArrowDown",
                                          ].includes(evt.key) &&
                                          evt.preventDefault()
                                        }
                                        onWheel={(e) =>
                                          e.target.blur()
                                        }
                                        name="gp_amount"
                                        value={newItem.gp_amount}
                                        onChange={handleChange}
                                        placeholder="e.g. 350"
                                      />
                                    </div>
                                  </div>
                                  <div className="form-group mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="decimal_allow"
                                        className="control-label"
                                      >
                                        {_t(t("Decimal Allow"))}
                                      </label>
                                    </div>
                                    <Select
                                      options={itemStatus}
                                      components={makeAnimated()}
                                      value={newItem.decimal_allow}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      maxMenuHeight="200px"
                                      onChange={(decimal_allow)=>handleSetSelect("decimal_allow", decimal_allow)}
                                      placeholder={
                                        _t(t("Decimal allow")) + ".."
                                      }
                                    />
                                  </div>
                                  <div className="form-group mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="is_qty_merge"
                                        className="control-label"
                                      >
                                        {_t(t("Is Qty Merge"))}
                                      </label>
                                    </div>
                                    <Select
                                      options={itemStatus}
                                      components={makeAnimated()}
                                      value={newItem.is_qty_merge}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      maxMenuHeight="200px"
                                      onChange={(is_qty_merge)=>handleSetSelect("is_qty_merge", is_qty_merge)}
                                    />
                                  </div>
                                  <div className="form-check mt-4 col-6 col-md-3">
                                    <input
                                      type="checkbox"
                                      className="form-check-input ml-0"
                                      id="specialCheck"
                                      checked={newItem.isSpecial}
                                      onChange={(e)=>handleCheckboxChange("isSpecial",e)}
                                    />
                                    <label
                                      className="form-check-label pointer-cursor ml-2"
                                      htmlFor="specialCheck"
                                    >
                                      {_t(t("Is Special?"))}
                                    </label>
                                  </div>
                                  <div className="form-check mt-4 col-6 col-md-3">
                                    <input
                                      type="checkbox"
                                      className="form-check-input ml-0"
                                      id="dealCheck"
                                      checked={newItem.isDeal}
                                      onChange={(e)=>handleCheckboxChange("isDeal",e)}
                                    />
                                    <label
                                      className="form-check-label pointer-cursor ml-2"
                                      htmlFor="dealCheck"
                                    >
                                      {_t(t("Is Deal?"))}
                                    </label>
                                  </div>
                                  <div className="form-group mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="image"
                                        className="control-label"
                                      >
                                        {_t(t("Image"))}
                                        <small className="text-secondary">
                                          ({_t(t("300 x 300 Preferable"))})
                                        </small>
                                      </label>
                                    </div>
                                    <div className="mb-1">
                                      <input
                                        type="file"
                                        className="form-control sm-text"
                                        id="image"
                                        name="image"
                                        onChange={handleItemImage}
                                      />
                                    </div>
                                  </div>
                                  <div className="form-check mt-2 col-6 col-md-3">
                                    <div className="mb-1">
                                      <label
                                        className="form-label mb-1"
                                        htmlFor="status"
                                      >
                                        {_t(t("Status"))}
                                        <span className="text-danger">*</span>
                                      </label>
                                    </div>
                                    <Select
                                      options={foodStatusForStatus || []}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newItem.status || ""}
                                      classNamePrefix="select"
                                      onChange={(status) => handleSetSelect("status", status)}
                                      maxMenuHeight="200px"
                                      placeholder={
                                        _t(t("Please select status")) + ".."
                                      }
                                      required
                                    />
                                  </div>
                                </div>
                              </div>    
                              {/* <div className="row">
                                {deptTagForSearch && (
                                  <div className="form-group mt-2 mb-1 col-12 col-md-6">
                                    <div className="mb-1">
                                      <label
                                        htmlFor="item_group"
                                        className="control-label"
                                      >
                                        {_t(t("Menu group"))}
                                        <span className="text-danger mr-1">
                                          *
                                        </span>
                                      </label>
                                    </div>
                                    <Select
                                      options={deptTagForSearch}
                                      components={makeAnimated()}
                                      value={selectedMenu}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      maxMenuHeight="200px"
                                      isMulti={true}
                                      closeMenuOnSelect={false}
                                      onChange={handleSelectedMenu}
                                      placeholder={
                                        _t(t("Please select menu")) + ".."
                                      }
                                    />
                                  </div>
                                )}
                                
                              </div> */}

                              {/* <div className="form-check mt-2 mx-3">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="propertyCheck"
                                  checked={newItem.hasProperty}
                                  onChange={handlePropertyCheckboxChange}
                                />
                                <label
                                  className="form-check-label pointer-cursor"
                                  htmlFor="propertyCheck"
                                >
                                  {_t(t("Has properties?"))}
                                </label>
                              </div>
                              {propertyGroupForSearch && [
                                newItem.hasProperty && (
                                  <div className="form-group mt-2 ml-4">
                                    <div className="mb-1">
                                      <label className="control-label">
                                        {_t(t("Add properties"))}
                                      </label>
                                    </div>
                                    <Select
                                      options={propertyGroupForSearch}
                                      components={makeAnimated()}
                                      getOptionLabel={(option) => option.name}
                                      getOptionValue={(option) => option.id}
                                      value={newItem.properties}
                                      className="basic-multi-select"
                                      classNamePrefix="select"
                                      isMulti
                                      closeMenuOnSelect={false}
                                      maxMenuHeight="200px"
                                      onChange={handleSetPropertes}
                                      placeholder={
                                        _t(
                                          t("Please select property groups")
                                        ) + ".."
                                      }
                                    />
                                  </div>
                                ),
                              ]}

                              <div className="form-check mt-2 mx-3">
                                <input
                                  type="checkbox"
                                  className="form-check-input"
                                  id="variationCheck"
                                  checked={newItem.hasVariation}
                                  onChange={handleVariationCheckboxChange}
                                />
                                <label
                                  className="form-check-label pointer-cursor"
                                  htmlFor="variationCheck"
                                >
                                  {_t(t("Has variations?"))}
                                </label>
                              </div> */}

                              <div className="form-group mt-5 pb-2">
                                <div className="col-lg-12">
                                  <button
                                    className="btn btn-primary px-3 rounded"
                                    type="submit"
                                  >
                                    {_t(t(id ? "Update" : "Save"))}
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>,
                          // end here
                        ]}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default NewFoodItemDeptAction;
